import { agentRoleOptions, departmentRoleOptions } from '@/shared/model/caseAssignment.model';
const ROLE_LABELS = new Map([...agentRoleOptions, ...departmentRoleOptions].map((option) => [option.role, option.label]));
const TRANSFER_REASON_LABELS = new Map([
    ['WORKLOAD_BALANCE', 'Workload balance'],
    ['EXPERTISE_REQUIRED', 'Expertise required'],
    ['ESCALATION', 'Escalation'],
    ['AGENT_REQUEST', 'Agent request'],
    ['SUPERVISOR_DECISION', 'Supervisor decision'],
    ['DEPARTMENT_CHANGE', 'Department change'],
    ['UNAVAILABLE', 'Unavailable'],
    ['CONFLICT', 'Conflict'],
    ['CUSTOMER_REQUEST', 'Customer request'],
]);
const TRANSFER_STATUS_LABELS = new Map([
    ['PENDING', 'Pending'],
    ['APPROVED', 'Approved'],
    ['COMPLETED', 'Completed'],
    ['REJECTED', 'Rejected'],
    ['CANCELLED', 'Cancelled'],
]);
function userDisplayName(user) {
    return user?.fullName ?? user?.name ?? user?.login ?? user?.username;
}
export function mapCaseTransferToListRow(transfer, kase) {
    const status = (transfer.status ?? 'PENDING');
    const kaseData = transfer.kase ?? kase;
    const reasonKey = transfer.reason ?? transfer.transferReason ?? '';
    const targetUser = transfer.toUserUsername ??
        userDisplayName(transfer.toUser) ??
        transfer.assignedUserUsername;
    const targetDepartment = transfer.toDepartment?.name ??
        transfer.assignedDepartment?.name ??
        (transfer.toDepartmentId != null
            ? String(transfer.toDepartmentId)
            : transfer.assignedDepartmentId != null
                ? String(transfer.assignedDepartmentId)
                : undefined);
    return {
        id: String(transfer.id ?? ''),
        caseId: String(kaseData?.id ?? transfer.kaseId ?? ''),
        assignmentId: String(transfer.caseAssignmentId ?? ''),
        sourceDisplayName: transfer.sourceDisplayName ??
            transfer.fromUserUsername ??
            userDisplayName(transfer.fromUser) ??
            transfer.requestedByUsername ??
            '—',
        roleDisplay: transfer.roleDisplay ??
            ROLE_LABELS.get(transfer.sourceRole ?? transfer.role ?? '') ??
            transfer.sourceRole ??
            transfer.role ??
            (targetUser ? 'Agent' : targetDepartment ? 'Department' : '—'),
        targetDisplayName: transfer.targetDisplayName ?? targetUser ?? targetDepartment ?? '—',
        reasonDisplay: TRANSFER_REASON_LABELS.get(reasonKey) ?? reasonKey ?? '—',
        status,
        statusDisplay: TRANSFER_STATUS_LABELS.get(status) ?? status,
        transferRequestDate: transfer.transferRequestDate ?? transfer.transferDate ?? transfer.createdDate ?? '',
        transferNotes: transfer.transferNotes ?? '',
        requestedByName: userDisplayName(transfer.requestedBy) ??
            userDisplayName(transfer.transferredBy) ??
            transfer.requestedByUsername ??
            transfer.fromUserUsername,
        approvedByName: userDisplayName(transfer.approvedBy) ?? transfer.approvedByUsername,
        approvalDate: transfer.approvalDate ?? transfer.approvedDate,
        case: kaseData ?? { id: transfer.kaseId },
    };
}
export function mapAssignmentToMyCaseRow(assignment, kase) {
    return {
        id: String(assignment.id ?? ''),
        caseId: String(assignment.kaseId ?? ''),
        assignmentId: String(assignment.id ?? ''),
        callerName: kase?.callerName,
        phoneNumber: kase?.phoneNumber,
        assignmentDisplayName: assignment.assignedUserUsername ?? kase?.currentPrimaryAgent?.username ?? '—',
        assignmentType: assignment.assignedDepartmentId ? 'Department' : 'Agent',
        assignmentRoleLabel: ROLE_LABELS.get(assignment.role ?? '') ?? assignment.role ?? '—',
        issueName: kase?.issue?.name,
        priority: kase?.priority,
        status: assignment.status ?? kase?.status,
        dateTime: assignment.assignedDate ?? kase?.createdDate,
        overallProgress: assignment.progressPercentage ?? kase?.overallProgress ?? 0,
        assignmentInTransferPending: Boolean(assignment.isInCaseTransferPending),
    };
}
